<template>
  <div>
    <b-input-group class="autocomplete-input-group">
      <b-form-input
        id="input-worker-source"
        size="sm"
        :disabled="isDisabled"
        v-model="query"
        :placeholder="items.length === 0 ? 'Создайте источник' : 'Выберите источник'"
        :state="state"
        autocomplete="off"
        class="autocomplete-input-group"
        @focus="onFocusIn"
        @blur="onFocusOut"
      />

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
        <b-button
          v-if="canCreateCatalog()"
          size="sm"
          variant="success"
          :disabled="isDisabled"
          @click="showModalCatalog"
          v-b-tooltip.hover.v-success
          title="Создать источник"
        >
          <font-awesome-icon icon="plus"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-worker-source" v-if="isFocus">
        <b-list-group-item
          v-for="(item, index) in filteredItems"
          :key="index"
          @mousedown="onClick(item)"
          button
        >
          {{ getItemListText(item) }}
        </b-list-group-item>
        <b-list-group-item v-if="items.length === 0 && query" disabled>
          <small>Ничего не найдено</small>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>

    <worker-source
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onWorkerSourceCreated"
    />

  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import WorkerSource from "./WorkerSource.vue";

export default {
  name: "WorkerSourceSelect",
  components: { WorkerSource },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean },
    id: { type: Number },
    state: { type: Boolean, default: null }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      workerSource: null,
      isModalVisible: false
    }
  },
  mounted() {
    this.getItems();
  },
  computed: {
    filteredItems() {
      if (!this.query) return this.items;

      const lowerQuery = this.query.toLowerCase();
      const currentItem = this.items.find(item => item.id === this.id);

      if (currentItem && currentItem.name.toLowerCase() === lowerQuery) return this.items;

      return this.items.filter(item => item.name.toLowerCase().includes(lowerQuery));
    }
  },
  methods: {
    async configure(id) {
      if (id > 0) {
        const result = await this.getWorkerSourceById(id);

        if (result && result.data) {
          this.query = result.data.name;
          this.workerSource = result.data;
        }
      } else {
        this.query = "";
      }
    },
    async onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.workerSource) {
        if (this.query !== this.workerSource.name) {
          this.query = this.workerSource.name;
        }
      } else {
        this.query = "";
      }
    },
    onClear() {
      this.query = "";
      this.workerSource = null;
      this.$emit('onSelect',null);
    },
    onClick(item) {
      this.query = item.name;
      this.workerSource = item;
      this.$emit('onSelect', item);
    },
    getItemListText(item) {
      return item.name;
    },
    async getItems() {
      const result = await this.getWorkerSources({ perPage: 500 });
      this.items = (result && result.data) ? result.data.items : [];
    },
    showModalCatalog() {
      this.isModalVisible = true;
    },
    async onWorkerSourceCreated(newItem) {
      this.items.push(newItem);
      this.onClick(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canCreateCatalog() {
      return this.hasPermission([PERM.CATALOG_WORKER_SOURCE_EDIT]);
    }
  },
  watch: {
    'id': {
      handler(newId) {
        this.configure(newId);
      }, immediate: true
    },
  }
}
</script>

<style scoped>
/* Autocomplete Select Input */
.autocomplete-worker-source {
  margin-top: 31px;
  max-height: 250px;
  overflow-y: auto;
  position: absolute;
  z-index: 1030;
  text-align: left;
}

.autocomplete-input-group {
  position: unset;
}

/* Autocomplete Select Input Group Item */
.autocomplete-worker-source .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerSources/WorkerSourceSelect.vue